export default "__VITE_ASSET__wkqfyKME__"